import {Button, Modal} from "antd";
import styled from "styled-components";
import {memo} from "react";
import {ISearchResult} from "../../../services/types.ts";
import {Link, useNavigate} from "react-router-dom";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteJobDemand} from "../../../services/api.ts";
import {RowItemWrapper} from "candidate/src/pages/searches/components/SearchItem.tsx";

export const SearchItem = memo(({item}: { item: ISearchResult }) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const deleteMutation = useMutation({
        mutationFn: (id: string) => deleteJobDemand(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['searches'] });
        },
    });

    const handleViewCandidates = () => {
        const queryParams = new URLSearchParams();

        // Construct position object if we have the data
        if (item.search_what_id && item.search_what_label) {
            const position = {
                id: item.search_what_id,
                label: item.search_what_label,
                created_at: 0,
                potential_jobs_id: 0,
                positions_id: 0,
            };
            queryParams.set('position', JSON.stringify(position));
        }

        // Construct location object if we have the data
        if (item.search_location_id && item.search_location_label) {
            const location = {
                id: item.search_location_id,
                label: item.search_location_label,
                label_client: item.search_location_label,
                label_candidate: item.search_location_label,
                created_at: 0,
                type: 'region',
                value: 0,
                pattern: '',
                search: '',
                default: '',
                radius: undefined,
                show: 1,
                show_client: 1,
                region: undefined,
            };
            queryParams.set('location', JSON.stringify(location));
        }

        navigate(`/candidates?${queryParams.toString()}`);
    };

    const handleDelete = () => {
        if (!item?.id) return;
        Modal.confirm({
            title: "Jobsuche wirklich löschen?",
            content: "Diese Aktion kann nicht rückgängig gemacht werden.",
            okText: "Ja",
            okType: "danger",
            cancelText: "Nein",
            onOk() {
                if (item.id) {
                    deleteMutation.mutate(item.id.toString());
                }
            },
        });
    };

    return (
        <RowItemWrapper>
            <MetaWrapper>
                <SearchTitle>{item.title ?? 'Search Title'}</SearchTitle>
                <SearchLocation>Was?: {item.search_what_label ?? 'N/A'}</SearchLocation>
                <SearchLocation>Wo?: {item.search_location_label ?? 'N/A'}</SearchLocation>
                <SearchLocation>Kandidatenvorschläge: {item.alert_label ?? 'N/A'}</SearchLocation>
            </MetaWrapper>
            <BtnGroup>
                <Button type="primary" onClick={handleViewCandidates}>Zu passenden Kandidaten</Button>
                <Link to={`/searches/${item.id}`}><Button style={{width: '100%'}}>Bearbeiten</Button></Link>
                <Button danger onClick={handleDelete} loading={deleteMutation.isPending}>Löschen</Button>
            </BtnGroup>
        </RowItemWrapper>
    );
});

const SearchTitle = styled.p`
    margin: 0;
    font-weight: bold;
    font-size: 16px;
`;

const SearchLocation = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    color: #424242;
`;

const BtnGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const MetaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
